export default {
  common: {
    errors: {
      title: "Ошибка",
      warning: "Внимание",
      note: "Примечание",
      searchSubscribers: "Поиск абонентов",
      pointAlreadyExists:
        "Показание с таким номером точки учета уже существует",
      payDateDiff: "Дата оплаты значительно позже оплачиваемого периода",
      readingNotBeCalc:
        "Показание, введенное для несуществующей точки учета, не будет учитываться в расчетах",
      conditionNotSet: "Условие не установлено",
      usernameNotFoundInDatabase: "Логин не найден в базе",
      usernameOrPasswordNotFound: "Логин или пароль отсутствуют",
      accessDenied: "Доступ запрещен",
      invalidUsernameOrPassword: "Некорректный логин или пароль",
      accountExpired: "Срок действия учетной записи завершен",
      sessionExpired: "Время жизни сессии истекло",
      networkError: "Ошибка при подключении к серверу"
    },
    menu: {
      massinput: {
        name: "Массовый ввод",
        enteringPayments: {
          name: "Платежи",
          desc:
            "Ввод коммунальных платежей абонентов, полученных от принимающих организаций"
        },
        enteringSubsidies: {
          name: "Субсидии",
          desc:
            "Ввод субсидий, компенсации инвалидам по зрению и т.д., полученных от отдела субсидий"
        }
      },
      subscribers: {
        name: "Абоненты",
        desc: "Поиск и просмотр информации об абонентах"
      },
      searchchange: {
        name: "Поиск и изменение",
        errorpayments: {
          name: "Ошибочные платежи",
          desc: "Просмотр и корректировка ошибочных платежей"
        }
      },
      paymentdocuments: {
        name: "Платежные документы",
        bankPay: {
          name: "Банковские платежи",
          desc: "Работа с банковскими платежами"
        },
        packsReceipts: {
          name: "Пачки квитанций/субсидий",
          desc: "Работа с заголовками пачек квитанций/субсидий"
        },
        relationship: {
          name: "Связь платежей и пачек",
          desc:
            "Установление соответствия между полученными платежными документами и пачками"
        },
        assignOperators: {
          name: "Назначение операторов",
          desc: "Назначение операторов для работы с пачками"
        },
        controlPacks: {
          name: "Контроль разноски пачек",
          desc: "Контроль правильности разноски пачек"
        },
        controlInetPays: {
          name: "Контроль internet-платежей",
          desc: "Контроль за поступлением internet-платежей"
        }
      },
      reports: {
        name: "Отчеты",
        desc: "Формирование отчетных форм"
      },
      acceptedshipment: {
        name: "Отчет о принятой отгрузке",
        desc:
          'Отчет для сравнения принятой отгрузки от "Поставщика" и "Сетевой компании"'
      },
      settings: {
        name: "Настройки",
        desc: "Пользовательские настройки"
      },
      user: {
        currentUser: "Пользователь",
        currentConnection: "Подключение",
        about: "О программе",
        settings: "Настройки",
        signOut: "Выход"
      }
    },
    about: {
      modal: {
        title: "О программе",
        descritpionAbon: "Начисление абонентской платы",
        descritpionComm: "за коммунальные услуги",
        clientVersion: "Версия клиента: {version}",
        serverVersion: "Версия сервера: {version}",
        apiVersion: "Версия сервера приложений: {version}"
      }
    },
    filter: {
      info: {
        periodWith: "Период с",
        periodTo: "по",
        sumMin: "Мин. сумма",
        sumMax: "Макс. сумма",
        statementSpaced: "Разнесенные выписки",
        statementSet: "Выписки в наборе",
        organization: "Организация",
        payment: "Способ оплаты",
        showSpaced: "Разнесенные пачки",
        statusPack: "Статус пачки",
        operator: "Оператор"
      },
      modal: {
        title: "Фильтр на отображение данных"
      },
      form: {
        dateRange: {
          title: "Период дат",
          from: "с",
          start: "Начальная дата",
          end: "Конечная дата",
          separator: "по"
        },
        sumRange: {
          title: "Сумма",
          from: "от",
          to: "до"
        },
        statementStatus: {
          title: "Состояние выписки",
          exploded: "Разнесенная",
          unexploded: "Неразнесенная"
        },
        organization: {
          title: "Организация"
        },
        payment: {
          title: "Способ оплаты"
        },
        showSpaced: {
          title: "Показать разнесенные"
        },
        statusPack: {
          title: "Статус пачки"
        },
        operator: {
          title: "Оператор"
        }
      }
    },
    compliance: {
      info: {
        datesDifference: "Разница между датами (в днях)",
        organizationsMatch: "Организации совпадают",
        paymentMethodsMatch: "Способы оплат совпадают",
        amountDifference: "Разница в сумме"
      },
      modal: {
        title: "Параметры соответствия платежей и пачек"
      },
      form: {
        datesDifference: {
          title: "Дата по банку",
          days: "дней"
        },
        organizationsMatch: {
          title: "Организации совпадают"
        },
        paymentMethodsMatch: {
          title: "Способы оплат совпадают"
        },
        amountDifference: {
          title: "Разница в сумме"
        }
      }
    },
    validations: {
      dateRange: {
        message: "Необходимо выбрать дату"
      },
      sumRange: {
        message: "Сумма от не может быть больше суммы до"
      },
      statementStatus: {
        message: "Необходимо выбрать тип выписки"
      },
      datebank: {
        message: "Необходимо выбрать дату",
        dateNow: "Дата по банку не может быть больше текущей даты",
        dateClose: "Дата по банку не может приходиться на закрытый месяц"
      },
      datepay: {
        message: "Необходимо выбрать дату",
        dateNow: "Дата оплаты платежа не может быть больше текущей даты",
        dateCompare: "Дата оплаты не может быть меньше даты создания абонента"
      },
      quantity: {
        message: "Укажите количество платежей",
        required: "Поле не может быть пустым",
        status:
          "Кол-во платежей в выписке и кол-во введенных платежей не совпадают"
      },
      countband: {
        required: "Поле не может быть пустым"
      },
      summa: {
        message: "Укажите сумму",
        required: "Поле сумма не может быть пустым",
        status:
          "Сумма платежей в выписке и сумма введенных платежей не совпадают"
      },
      beneficiaryAccount: {
        message: "Необходимо выбрать р/счет получателя"
      },
      paymentStatus: {
        message: "Необходимо выбрать тип платежа"
      },
      codefirme: {
        message: "Необходимо выбрать отправителя"
      },
      payment: {
        message: "Необходимо выбрать способ оплаты"
      },
      encoding: {
        message: "Необходимо выбрать кодировку"
      },
      uploadFile: {
        message: "Необходимо выбрать как минимум один файл",
        onlyOne: "Можно загрузить только один файл"
      },
      confirmeCodefirme: {
        message: "Необходимо выбрать организацию"
      },
      paynumber: {
        required: "Поле № документа не может быть пустым"
      },
      rcount: {
        message: "Необходимо выбрать р/счет плательщика"
      },
      summaPack: {
        aboveZero: "Должна быть больше нуля",
        notEqualZero: "Не может быть равна нулю"
      },
      userPayment: {
        message: "Необходимо выбрать оператора"
      },
      codeImport: {
        message: "Необходимо выбрать тип входных данных"
      },
      files: {
        message: "Необходимо добавить файл для импорта"
      },
      reasonStorn: {
        message: "Необходимо выбрать причину"
      },
      statusCode: {
        message: "Необходимо выбрать статус пачки"
      },
      confirmDateBank: {
        message: "Необходимо выбрать дату"
      },
      codepay: {
        message: "Необходимо выбрать назначение платежа"
      },
      sumPay: {
        message: "Сумма не может быть пустой",
        sumGrtZero: "Сумма платежа должна быть больше нуля"
      },
      datePayPeriod: {
        message: "Необходимо указать дату начала периода",
        datePayEnd: "Необходимо указать дату окончания периода",
        datePayCompare: "Начальная дата должна быть меньше конечной"
      },
      reasonReturnPack: {
        message: "Необходимо выбрать причину возврата пачки"
      },
      massInputQuantity: {
        message: "Поле не может быть пустым",
        quantityGrtZero: "Кол-во квитанций должно быть больше нуля",
        subscribersGrtZero: "Кол-во абонентов должно быть больше нуля"
      },
      massInputTotalSum: {
        message: "Поле не может быть пустым",
        sumGrtZero: "Общая сумма должна быть больше нуля"
      },
      sumBegin: {
        beginGtEnd: "Начальная сумма не может быть больше конечной",
        endSumEmpty: "Необходимо выбрать конечную сумму"
      },
      sumEnd: {
        endLtBegin: "Конечная сумма не может быть меньше начальной",
        beginSumEmpty: "Необходимо выбрать начальную сумму"
      },
      dateBegin: {
        beginIsAfterEnd: "Начальная дата не может быть больше конечной",
        endDateEmpty: "Необходимо выбрать конечную дату"
      },
      dateEnd: {
        endIsBeforeBegin: "Конечная дата не может быть меньше начальной",
        beginDateEmpty: "Необходимо выбрать начальную дату"
      }
    },
    gridColumns: {
      nameaccount: "Р/счет",
      datebank: "Дата по банку",
      datebankPay: "Дата перечисления",
      quantityPay: "Кол-во платежей",
      totalSumma: "Общая сумма",
      summa: "Сумма",
      sumwithoutprof: "Сумма без услуг",
      summtrans: "Сумма перечисления",
      summpay: "Сумма оплат",
      status: "Состояние",
      astatus: "Ком. сбор",
      datebeginfact: "Дата",
      dateDelete: "Дата удаления",
      username: "Оператор",
      namefirme: "Плательщик",
      namefirmeSender: "Отправитель",
      namefirmeSenderPay: "Отправитель платежа",
      okpo: "ОКПО",
      okpoPay: "ОКПО плательщика",
      datepay: "Дата оплаты",
      paynumber: "№ платежа",
      mess: "Примечание",
      npack: "Связан с пачкой",
      npackStatus: "Статус платежа",
      npackSystem: "Системный номер пачки",
      kindname: "Способ оплаты",
      countband: "Кол-во бандеролей",
      countbands: "Бандеролей",
      quantity: "Кол-во квитанций",
      quantitys: "Квитанций",
      sumprof: "За услуги",
      isimport: "Импорт",
      packnumber: "Номер пачки",
      abcode: "Л/счет",
      abcodeLong: "Лицевой счет",
      fio: "ФИО",
      payname: "Назначение платежа",
      dateval: "Дата снятия показаний",
      counter: "Показание",
      impFile: "Файл",
      processed: "Обработано",
      transferid: "Код реестра",
      statusname: "Статус",
      nband: "№",
      countpay: "Кол-во",
      countpays: "Кол-во оплат",
      abcodeNumber: "Аб. номер",
      nameplat: "Услуга",
      adress: "Адрес",
      intkey: "Код платежа",
      reasonname: "Причина возврата",
      clientId: "ID",
      regionName: "Район",
      streetName: "Улица",
      nHouse: "№ дома",
      charHouse: "Буква",
      nFlat: "Квартира",
      charFlat: "Буква кв-ры",
      phone: "Телефон",
      dateCreate: "Открыт",
      dateClose: "Закрыт",
      arch: "Архив",
      postIndex: "Почтовый индекс",
      countRoom: "Номер участка",
      partyHouse: "Подъезд",
      floor: "Этаж",
      topIndex: "№ точки учета",
      service: "Услуга",
      zone: "Зона",
      reading: "Показание",
      status: "Учитываемое",
      payment: "Платеж",
      error: "Ошибка",
      npack: "Пачка",
      sumorig: "Сумма в валюте оплаты",
      currencyname: "Валюта оплаты",
      bank: "Банк",
      validity: "Период действия",
      datebegin: "Дата начала",
      dateend: "Дата окончания",
      makingEntry: "Внесение записи",
      house: "Дом",
      charHouseLong: "Буква дома",
      charFlatLong: "Буква квартиры",
      closeReasonName: "Причина закрытия л/счета",
      habitName: "Тип строения",
      propertyName: "Тип собственности",
      npack: "№ пачки",
      lists: "Листов",
      subsidiesSocBenefits: "Субсидий/соц.доплат",
      appointmentDate: "Дата назначения",
      dateBeginAction: "Начало действия",
      dateEndAction: "Окончание действия",
      dateReading: "Дата снятия показания",
      organization: "Организация"
    },
    types: {
      status: {
        posting: "разнесена",
        inSet: "в наборе"
      },
      astatus: {
        yes: "есть",
        no: "нет"
      },
      npackStatus: {
        alien: "чужой",
        associatedPack: "связан с пачкой",
        expectedPack: "ожидается пачка"
      },
      processed: {
        yes: "да",
        no: "нет"
      }
    },
    options: {
      payment: {
        zero: "должен быть привязан к соотвествующей пачке",
        one: "чужой"
      },
      searchTypes: {
        matches: "= совпадает",
        contains: "* содержит",
        startsOn: "> начинается на",
        endsOn: "< заканчивается на"
      },
      searchDateTypes: {
        equal: "равна",
        between: "между"
      }
    },
    buttons: {
      filter: "Фильтр",
      compliance: "Соотвествия",
      add: "Добавить",
      edit: "Изменить",
      delete: "Сторнировать",
      deletePacks: "Удаленные пачки",
      remove: "Удалить",
      removeAll: "Удалить все",
      fix: "Исправить",
      distribute: "Разнести",
      import: "Импорт",
      imports: "Импортировать",
      report: "Отчет",
      importDots: {
        import: "Импортировать...",
        payments: "платежи",
        subsidies: "субсидии",
        dbfFile: "DBF-файл",
        csvFile: "CSV-файл"
      },
      extraDots: {
        extra: "Дополнительно...",
        indefinite: "посмотреть квитанции с неопределенными показаниями"
      },
      viewDots: {
        view: "Вид",
        optimal: "Оптимальный",
        full: "Полный"
      },
      alien: "Чужой",
      posting: "Разнести",
      submit: "Подтвердить",
      cancel: "Отменить",
      refund: "Возвратить",
      selectFile: "Выбрать файл",
      addFile: "Добавить файл",
      deleteFile: "Удалить файл",
      upload: "Загрузить",
      close: "Закрыть",
      link: "Связать",
      linkAndPosting: "Связать и Разнести",
      packForPayment: "Создать пачку по платежу",
      assign: "Назначить",
      unassign: "Освободить",
      receipts: "Квитанции",
      moveToNextMonth: "Перенести на следующий месяц",
      cancelReceivedRegistry: "Отменить полученный результат",
      cancelSubscriberPayment: "Отменить оплату абонента",
      confirmYes: "Да",
      confirmNo: "Нет",
      confirmOk: "OK",
      infoPay: "Информация о платеже",
      errorPayments: "Ошибочные платежи", // delete this ?
      searchSubscribers: "Поиск абонентов",
      searchPayments: "Поиск платежей",
      subscriberCard: "Карточка абонента",
      search: "Найти",
      clear: "Очистить",
      aboutClient: "О клиенте",
      return: "Вернуть",
      postpone: "Отложить",
      distributeAll: "Разнести все",
      refreshList: "Обновить список",
      check: "Проверить",
      save: "Сохранить"
    },
    components: {
      select: {
        placeholder: "Выбор"
      },
      datePicker: {
        placeholder: "Дата",
        today: "Сегодня",
        yesterday: "Вчера"
      }
    },
    reference: {
      statusName: {
        inSet: "в наборе",
        inPosting: "в разноске",
        spaced: "разнесена",
        notConnected: "не связана",
        erroneous: "ошибочная",
        canceled: "сторнирована"
      },
      paymentName: {
        preparationPayment: "подготовка к оплате",
        paymentMade: "оплата совершена",
        paymentNotMade: "оплата не совершена",
        undefined: "не определен"
      },
      deliveryName: {
        moneySent: "деньги отправлены",
        paymentNotDeterm: "платеж не определен",
        mismatchAmounts: "несоответствие сумм",
        undefined: "не определен"
      }
    },
    checkVersion: {
      api: "Версия API должна быть",
      server: "Версия сервера должна быть",
      callTo: "или выше, обратитесь к администратору для обновления сервера",
      serverError: "Ошибка соединения на сервере:",
      dataBase: "Версия базы данных",
      appServer: "не соответствует версии сервера приложений"
    },
    address: {
      street: "ул. ",
      house: " д.",
      flat: " кв.",
      address: "адрес:",
      abcode: "л/с"
    },
    route: {
      leave:
        "Остались еще неразнесенные пачки. Желаете оставить их неразнесенными?"
    }
  }
};
